<template>
  <div>
    <!--タイトル-->
    <Header></Header>

    <!--詳細-->
    <p>
      {{ content }}
    </p>

    <nav class="navbar fixed-bottom navbar-expand-sm navbar-dark bg-dark">
      <button class='btn btn-lg btn-secondary' v-on:click='prevAction'>戻る</button>
    </nav>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'

export default {
  mounted: function () {
    
  },
  methods: {
    ...mapActions('WebGisModule', {
      'prevAction': 'prevAction'
    }),
  },
  computed: {
    ...mapGetters('WebGisModule', {
      'content': 'content',
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/WebGisDetail.vue